const faqData = [
    {
        id: 1,
        question: 'Does the package price include all expenses?',
        answer: "Yes. The package includes visa fees, flight ticket, hotel, meals and other expenses. You don't need to pay extra."
    },
    {
        id: 2,
        question: 'Do you help arrange my travel visa?',
        answer: "Yes. We'll help you in visa application as well as obtaining Swiss Schengen visa."
    },
    {
        id: 3,
        question: "How many people can join a tour?",
        answer: "We keep our group sizes low so our local guides can give more personal attention. You can expect up to 15 travellers one trip."
    },
    {
        id: 4,
        question: "I want to know more about the hotels I will be staying at.",
        answer: "You will be staying at 4-star hotels. In some destinations, you can expect 3-star inns."
    },
    {
        id: 5,
        question: "I'm a single traveller. Can I get a single room?",
        answer: "Yes. The accomodation is a twin share basis and if you are travelling on your own, you'll be sharing a room with another traveller of the same sex. However, extra fees will be charged if you request a single room. The cost and details may vary by trip."
    },
    {
        id: 6,
        question: "Can I continue staying in Switzerland after the tour ends?",
        answer: "Yes, you can stay as long as your visa permits. Please let us know before the trip starts so we can make adjustments for your accomodation and return flight."
    },
    {
        id: 7,
        question: "What will the food be like on my trip?",
        answer: "We arrange hotel buffets for breakfast. As for lunch and dinner, both local and international cuisines are prepared. In addition to this, our flexible itineraries often allow you to eat with the group or branch out on your own."
    },
    {
        id: 8,
        question: "Who will be the tour leader?",
        answer: "While we can't tell you who your tour leader is prior to departure, we can tell you they are experienced and professional because they've been travelling there for years."
    },
    {
        id: 9,
        question: "I have to cancel the trip booking. What do I do?",
        answer: "We understand that cancellations happen. As soon as you know that you have to cancel, please call the office or send us an email as soon as possible. Please note that we cannot provide a refund if trip cancellation is ten days before the trip."
    },
    {
        id: 10,
        question: "Can you explain about the custom package plan?",
        answer: "Depending on duration of the trip and destinations, the cost and details may vary. We will make a custom plan as per your requirements. The details of the trip will be provided to you in 2 days."
    },
    {
        id: 11,
        question: "Do you provide free water bottles throughout the trip?",
        answer: "Yes, water bottles are unlimited and beverages will be served in some occasions."
    }
];

export default faqData;